import {
    GENERATE_RESIDUAL_RISK_START,
    GENERATE_RESIDUAL_RISK_SUCCESS,
    GENERATE_RESIDUAL_RISK_FAILURE,
    UPDATE_RESIDUAL_RISK,
    ANALYZE_ACTIONPLAN_START,
    ANALYZE_ACTIONPLAN_SUCCESS,
    ANALYZE_ACTIONPLAN_FAILURE,
    SAVE_RESIDUAL_RISK_START,
    SAVE_RESIDUAL_RISK_SUCCESS,
    SAVE_RESIDUAL_RISK_FAILURE,
    FETCH_RESIDUAL_RISK_START,
    FETCH_RESIDUAL_RISK_SUCCESS,
    FETCH_RESIDUAL_RISK_FAILURE,
  } from './actionTypes';
  
  // Selectors from above
  import { selectRiskDetails, selectControlsForRisk, buildActionPlanData } from '../selectors/residualRiskSelectors';
  import { debounce } from 'lodash';
  export const generateResidualRisk = (modelId, riskId) => {
    return async (dispatch, getState) => {
      dispatch({ type: GENERATE_RESIDUAL_RISK_START, payload: { modelId, riskId } });
  
      try {
        const state = getState();
        const riskData = selectRiskDetails(state, modelId, riskId);
        const controlsData = selectControlsForRisk(state, riskId);
  
        // If you want *all the data* from each risk cause, you can embed them directly in 'riskData'.
        // For example, riskData.riskSources has the entire cause structure.
  
        const body = { modelId, riskId, riskData, controlsData };
        const response = await fetch('/.netlify/functions/generateResidualRisk', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
  
        if (!response.ok) {
          throw new Error('Failed to call generateResidualRisk function');
        }
  
        const json = await response.json();
        // Fallback for legacy: try residualNarrative if keys missing
        const residual_rating = json.residual_rating ?? null;
        const residual_explanation = json.residual_explanation ?? json.residualNarrative ?? '';
        dispatch({
          type: GENERATE_RESIDUAL_RISK_SUCCESS,
          payload: { modelId, riskId, residual_rating, residual_explanation },
        });
      } catch (error) {
        dispatch({
          type: GENERATE_RESIDUAL_RISK_FAILURE,
          payload: { modelId, riskId, error: error.message },
        });
      }
    };
  };




export const updateResidualRisk = (modelId, riskId, overrideData) => {
  // overrideData = { residual_rating, residual_explanation, action_plan_rating, action_plan_analysis }
  return {
    type: UPDATE_RESIDUAL_RISK,
    payload: { modelId, riskId, overrideData },
  };
};

export const analyzeActionPlan = (modelId, riskId, riskName) => {
  return async (dispatch, getState) => {
    dispatch({ type: ANALYZE_ACTIONPLAN_START, payload: { modelId, riskId, riskName } });
    try {
      const state = getState();
      const actionPlanData = buildActionPlanData(state, riskId);

      const body = { modelId, riskId, riskName, actionPlanData };
      const response = await fetch('/.netlify/functions/analyzeActionPlan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Failed to call analyzeActionPlan function');
      }

      const json = await response.json();
      // Fallback for legacy: try analysisText if keys missing
      const action_plan_rating = json.action_plan_rating ?? null;
      const action_plan_analysis = json.action_plan_analysis ?? json.analysisText ?? '';
      const action_plan_short_summary = json.action_plan_short_summary ?? '';

      dispatch({
        type: ANALYZE_ACTIONPLAN_SUCCESS,
        payload: { modelId, riskId, action_plan_rating, action_plan_analysis, action_plan_short_summary },
      });
    } catch (error) {
      dispatch({
        type: ANALYZE_ACTIONPLAN_FAILURE,
        payload: { modelId, riskId, error: error.message },
      });
    }
  };
};

  export const saveResidualRisk = (evaluationData) => async (dispatch) => {
    dispatch({ type: SAVE_RESIDUAL_RISK_START });
    try {
      const response = await fetch('/.netlify/functions/saveResidualRisk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(evaluationData),
      });
      if (!response.ok) {
        throw new Error('Failed to save residual risk');
      }
      const data = await response.json();
      dispatch({ type: SAVE_RESIDUAL_RISK_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: SAVE_RESIDUAL_RISK_FAILURE, payload: error.message });
    }
  };
  
  // Debounced version (e.g., 500ms delay)
  export const debouncedSaveResidualRisk = debounce(
    (dispatch, evaluationData) => {
      dispatch(saveResidualRisk(evaluationData));
    },
    500
  );

  export const fetchResidualRisk = (modelId) => {
    return async (dispatch) => {
      dispatch({ type: FETCH_RESIDUAL_RISK_START, payload: { modelId } });
      try {
        const response = await fetch('/.netlify/functions/fetchResidualRisk', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ modelId }),
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch residual risk');
        }
        
        const result = await response.json();
        dispatch({
          type: FETCH_RESIDUAL_RISK_SUCCESS,
          payload: { modelId, residualRisk: result.data.rows },
        });
      } catch (error) {
        dispatch({
          type: FETCH_RESIDUAL_RISK_FAILURE,
          payload: { modelId, error: error.message },
        });
      }
    };
  };